import { useCallback } from 'react';
import { batch } from 'react-redux';
import { request } from 'src/common/request';
import { blocksActions } from 'src/redux/reducers/blocks';
import { collectionViewsActions } from 'src/redux/reducers/collection-views';
import { dispatch } from 'src/redux/store';
import type { NextBlock } from 'src/redux/types';
import { setAppUiState } from 'src/services/app';

/**
 * 获取 space 跟页面
 * 用于显示左侧菜单
 */

export const useFetchSharePages = () => {
  const fetchSpaceSharePages = async (spaceId: string) => {
    const data = await request.infra.getSpaceUserSharedPages(spaceId);
    const {
      pages,
      recordMap: { blocks, collectionViews },
    } = data;

    batch(() => {
      dispatch(blocksActions.update({ blocks: blocks as Record<string, NextBlock> }));
      if (collectionViews) {
        dispatch(collectionViewsActions.update(collectionViews));
      }
      setAppUiState({ $sharedPages: pages });
    });
  };

  return useCallback(fetchSpaceSharePages, []);
};
